// This code shouldn't be like this, need to be refactor
// hint => 8 is 8px that used for padding and margin sizes in Material UI theme

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const handleHeight = (showHeaderFooter) => {
  const windowWidth = window.innerWidth;

  // layout variables (initial with desktop)
  let headerHeight = showHeaderFooter ? 70 : 0;
  const footerHeight = showHeaderFooter ? 60 : 0;
  const navBoxHeight = showHeaderFooter ? 60 + 8 : 0;
  const containerPadding = showHeaderFooter ? 8 * 4 : 0;
  const desktopContainerHeight = headerHeight + footerHeight + navBoxHeight + containerPadding;
  let newHeight = window.innerHeight - desktopContainerHeight;

  if (windowWidth <= 900) {
    headerHeight = showHeaderFooter ? 55 : 0;
    const mobileBottomPadding = showHeaderFooter ? 70 : 0;
    const mobileContainerHeight = headerHeight + containerPadding + mobileBottomPadding;
    newHeight = window.innerHeight - mobileContainerHeight;
  }

  return newHeight;
};

const useHeight = () => {
  const layout = useSelector((state) => state.layout);
  const showHeaderFooter = layout.showHeaderFooter;

  const [height, setHeight] = useState();

  const handleSetHeight = () => {
    const height = handleHeight(showHeaderFooter);
    setHeight(height);
  };

  useEffect(() => {
    window.addEventListener("resize", handleSetHeight);

    return () => {
      window.removeEventListener("resize", handleSetHeight);
    };
  }, []);
  useEffect(() => {
    handleSetHeight();
  }, [showHeaderFooter]);

  return height ? `${height}px` : null;
};

export default useHeight;
